/* XIIW V9 — Display an estimated delivery date window under the product price.
   DE: 3-5 business days (Mon-Fri, excluding nationwide German holidays).
   Other shipping countries: 3-9 weekdays (local holidays are not known).
   Dates are anchored to the German warehouse day in Europe/Berlin.
   This is an estimate, not a binding delivery guarantee. */
(function () {
  'use strict';

  var DAY_MS = 86400000;
  var holidayCache = Object.create(null);

  function utcDate(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day));
  }

  function plusDays(date, number) {
    return new Date(date.getTime() + number * DAY_MS);
  }

  function dateKey(date) {
    return date.toISOString().slice(0, 10);
  }

  function easterSunday(year) {
    // Gregorian computus (Meeus/Jones/Butcher algorithm).
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k + 7) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return utcDate(year, month, day);
  }

  function germanNationalHolidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    var easter = easterSunday(year);
    var days = [
      utcDate(year, 1, 1),
      utcDate(year, 5, 1),
      utcDate(year, 10, 3),
      utcDate(year, 12, 25),
      utcDate(year, 12, 26),
      plusDays(easter, -2),   // Good Friday
      plusDays(easter, 1),    // Easter Monday
      plusDays(easter, 39),   // Ascension Day
      plusDays(easter, 50)    // Whit Monday
    ];
    holidayCache[year] = new Set(days.map(dateKey));
    return holidayCache[year];
  }

  function germanToday() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Berlin',
      year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = Number(part.value); });
    return utcDate(values.year, values.month, values.day);
  }

  function addBusinessDays(start, count, country) {
    var day = new Date(start.getTime());
    var added = 0;
    var attempts = 0;
    while (added < count && attempts < 90) {
      day = plusDays(day, 1);
      attempts += 1;
      var weekday = day.getUTCDay();
      if (weekday === 0 || weekday === 6) continue;
      if (country === 'DE' && germanNationalHolidays(day.getUTCFullYear()).has(dateKey(day))) continue;
      added += 1;
    }
    return day;
  }

  function formatRange(first, last) {
    var monthFormatter = new Intl.DateTimeFormat('de-DE', {month: 'long', timeZone: 'UTC'});
    var firstDay = String(first.getUTCDate()).padStart(2, '0');
    var lastDay = String(last.getUTCDate()).padStart(2, '0');
    var sameYear = first.getUTCFullYear() === last.getUTCFullYear();
    var sameMonth = sameYear && first.getUTCMonth() === last.getUTCMonth();
    if (sameMonth) {
      return firstDay + '.–' + lastDay + '. ' + monthFormatter.format(last);
    }
    var left = firstDay + '. ' + monthFormatter.format(first);
    var right = lastDay + '. ' + monthFormatter.format(last);
    if (!sameYear) {
      left += ' ' + first.getUTCFullYear();
      right += ' ' + last.getUTCFullYear();
    }
    return left + ' – ' + right;
  }

  function renderDeliveryDates() {
    var elements = document.querySelectorAll('[data-xiiw-delivery]');
    if (!elements.length) return;
    var today;
    try {
      today = germanToday();
    } catch (error) {
      // Very old browsers without Intl time-zone support: use local date.
      var now = new Date();
      today = utcDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
    }
    elements.forEach(function (element) {
      var target = element.querySelector('[data-xiiw-delivery-date]');
      if (!target) return;
      var minDays = Number(element.getAttribute('data-min-days'));
      var maxDays = Number(element.getAttribute('data-max-days'));
      if (!Number.isInteger(minDays) || !Number.isInteger(maxDays) || minDays < 1 || maxDays < minDays) return;
      var country = element.getAttribute('data-country') || '';
      var start = addBusinessDays(today, minDays, country);
      var end = addBusinessDays(today, maxDays, country);
      target.textContent = formatRange(start, end);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderDeliveryDates, {once: true});
  } else {
    renderDeliveryDates();
  }
  document.addEventListener('shopify:section:load', renderDeliveryDates);
})();
